import { Injectable } from '@angular/core';
import { of } from 'rxjs';

import { ApiHttp } from '@core/api/api-http';
import { OpportunityApiHttp } from '@core/api/opportunity-api-http';
import { PageRequest } from '@shared/components/data-table/models/page-request';
import { PaginatedResponse } from '@shared/components/data-table/models/paginated-response';
import { Report } from '@shared/enums/report.enum';

export interface ReportResponse<T> {
  data: T[];
}

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  constructor(private api: OpportunityApiHttp) {}
  get<T>(report: Report) {
    return this.api.getWithFeatures<PaginatedResponse<T>>(`/reports/${report}`);
  }
  getSummaryWithPagination<T>(report: Report, pageRequest?: PageRequest) {
    const options = ApiHttp.getStandardOptions();
    if (pageRequest) {
      options.params = pageRequest;
    }
    return this.api.getWithFeatures<PaginatedResponse<T>>(
      `reports/${report}/summary`,
      options
    );
  }
  getSummary<T>(report: Report) {
    return this.api.getWithFeatures<ReportResponse<T>>(`reports/${report}/summary`);
  }
  getDetails<T>(report: Report) {
    return this.api.getWithFeatures<ReportResponse<T>>(`reports/${report}/details`);
  }
}
